import { render, staticRenderFns } from "./WatSewCollisionsInfo.vue?vue&type=template&id=59e1ddaa&scoped=true&"
import script from "./WatSewCollisionsInfo.vue?vue&type=script&lang=js&"
export * from "./WatSewCollisionsInfo.vue?vue&type=script&lang=js&"
import style0 from "./WatSewCollisionsInfo.vue?vue&type=style&index=0&id=59e1ddaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1ddaa",
  null
  
)

export default component.exports